module.exports = __webpack_public_path__ + "img/fiso.38956598.jpg";